import * as React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@fluentui/react-components";
import useResizeCount from "../hooks/useResizeCount";

const fadeIn = {
  from: {
    opacity: 0,
    transform: "translateY(10px)",
  },
  to: {
    opacity: 1,
    transform: "translateY(0)",
  },
};

const glow = {
  "0%, 100%": { boxShadow: "0 0 6px 2px rgba(136, 204, 248, 0.4)" },
  "50%": { boxShadow: "0 0 18px 6px rgba(0, 61, 174, 0.5)" },
};

const useStyles = makeStyles({
  root: {
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    alignItems: "center",
    maxWidth: "500px",
    background: "linear-gradient(#fff, #fff) padding-box, linear-gradient(180deg, #88CCF8, #003DAE) border-box",
    border: "3px solid transparent",
    borderRadius: "10px",
    position: "absolute",
    zIndex: 1000,
    fontFamily: "Inter, sans-serif",
    opacity: 0,
    animationName: [fadeIn, glow],
    animationDuration: "0.5s, 2.5s",
    animationFillMode: "forwards, none",
    animationDelay: "0.9s, 1.4s",
    animationTimingFunction: "ease, ease-in-out",
    animationIterationCount: "1, infinite",
  },
  p: {
    margin: 0,
    alignSelf: "flex-start",
    textAlign: "left",
  },
  icon: {
    alignSelf: "flex-start",
  },
});

const InfoBox = ({ title, label, icon, style = {} }) => {
  const styles = useStyles();
  const resizeCount = useResizeCount();

  return (
    <div
      key={resizeCount}
      style={{ ...style, animationDelay: resizeCount ? ".3s" : undefined }}
      className={styles.root}
    >
      {!!icon && <i className={styles.icon}>{icon}</i>}
      {!!title && <h4>{title}</h4>}
      <p className={styles.p}>{label}</p>
    </div>
  );
};

InfoBox.propTypes = {
  style: PropTypes.object,
  title: PropTypes.string,
  label: PropTypes.any.isRequired,
  icon: PropTypes.any,
};

export default InfoBox;
